<template>
    <div>
        <div>
            <div class="mb-3 text-primary-500">Se crearán automaticamente una devolución para:</div>
            <div class="text-gray-800 text-semibold mb-2">Cliente</div>
            <div class="flex flex-col space-y-2">
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Nombre
                    </div>
                    <div>
                        {{ destination.destino_nombre }}
                    </div>
                </div>
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Correo electrónico
                    </div>
                    <div>
                        {{ destination.destino_email }}
                    </div>
                </div>
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Código Postal
                    </div>
                    <div>
                        {{ destination.destino_cp }}
                    </div>
                </div>
            </div>
        </div>
        <Divider />
        <div>
            <div class="text-gray-800 text-semibold mb-2">Sucursal</div>
            <div class="flex flex-col space-y-2">
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Nombre
                    </div>
                    <div>
                        {{ origin.origen_nombre }}
                    </div>
                </div>
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Correo electrónico
                    </div>
                    <div>
                        {{ origin.origen_email }}
                    </div>
                </div>
                <div>
                    <div
                        class="uppercase text-[10px] font-semibold text-gray-500"
                    >
                        Código postal
                    </div>
                    <div>
                        {{ origin.origen_cp }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MultistepReturnDetails",
    props: {
        origin: Object,
        destination: Object,
    },
};
</script>
